var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-between"},[_c('p',[_vm._t("countryChannel"),_vm._t("icon")],2),_c('p',[_vm._t("price",function(){return [_vm._v("0 €")]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }